import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Diagnostic, WecdevError } from '@lmnop/web-core';
import { TRANSLATE_FILES_DIRECTORY__INJECTION_TOKEN, IAngularErrorHandler } from 'angular-core-src';

@Injectable()
export class AngularErrorHandler implements IAngularErrorHandler {
    constructor(
        @Inject(TRANSLATE_FILES_DIRECTORY__INJECTION_TOKEN)
        private translateFilesDirectory: string
    ) {}

    public handleError(error: any): void {
        if (error && error.rejection && error.rejection.name === 'HttpErrorResponse' && error.rejection.url.startsWith(this.translateFilesDirectory)) {
            //the TranslateHttpLoader throw an error when the browser currentlanuages is not exists in _location directory
            //we skip errorhandling, because we have fallback languae set
            return;
        }
        if (error && error instanceof HttpErrorResponse && error.url.startsWith(this.translateFilesDirectory)) {
            //the TranslateHttpLoader throw an error when the browser currentlanuages is not exists in _location directory
            //we skip errorhandling, because we have fallback languae set
            return;
        }
        if (error.message && error.message === WecdevError.ERROR_HANDLED) {
            return;
        }
        if (error.toString().includes(WecdevError.CLASS_NAME) && error.toString().includes(WecdevError.ERROR_HANDLED)) {
            return;
        }
        Diagnostic.handleError(error);
    }
}
